export default {
  data() {
    return {
      users: [
        {
          id: null,
          username: null,
        },
      ],
      usersWithKey: {
        id: {
          id: null,
          username: null,
        },
      },
    };
  },
  methods: {
    getUsers() {
      const app = this;
      const roles = ["ADMIN", "NORMAL"];

      roles.forEach(function(role) {
        app.$restClient.qppUsers
          .getUsersByRole(role)
          .then((response) => {
            app.users.push(...response.data);
            app.$helper.sortByKey(app.users, "username");
            app.usersLoaded = true;
            if (app.wRoomsLoaded) app.wRoomsAndUsersLoaded = true;
          })
          .catch((err) => {
            console.log(err);
            app.$notify.notifyError({ title: this.$t("failed") });
          });
      });
    },
  },
};
